import type { FC } from "react";

import styles from "./Image.module.scss";

export type ImageProps = {
  url: string;
  alt?: string;
  className?: string;
};

/**
 * @deprecated use ImageBehaviour from @jti/ui instead
 */

export const Image: FC<ImageProps> = ({ url, alt, className }) => {
  const accessibilityProps = alt ? ({ role: "img", "aria-label": alt } as const) : ({ "aria-hidden": true } as const);

  return (
    <div
      className={`${styles.container} ${className ? className : ""}`}
      style={{ backgroundImage: `url(${url})` }}
      {...accessibilityProps}
    ></div>
  );
};
